import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from "@mui/styles";
import InputAdornment from "@mui/material/InputAdornment";
import Icon from "@mui/material/Icon";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import styles from '../styles/loginPage.js';
//import styles from '../styles/staticPages.js';
import image from "assets/img/background.jpg";
import { useSelector, useDispatch } from "react-redux";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AlertDialog from '../components/AlertDialog';
import CountrySelect from '../components/CountrySelect';
import { FirebaseContext, api } from 'common';
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import { GoogleLogin } from '@react-oauth/google';
import { MAIN_COLOR } from "../common/sharedFunctions.js"
import { colors } from 'components/Theme/WebTheme.js';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Typography } from "@mui/material";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { House } from '@mui/icons-material';
import GoogleMapsAutoComplete from 'components/GoogleMapsAutoComplete.js';

const useStyles = makeStyles(styles);

export default function LoginPage(props) {
  const { authRef, RecaptchaVerifier, signInWithPhoneNumber } = useContext(FirebaseContext);
  const {
    googleLogin,
    clearLoginError,
    mobileSignIn,
    sendResetMail,
    verifyEmailPassword,
    requestMobileOtp,
    verifyMobileOtp,
    mainSignUp,
    editDeliveryLocations,
    checkUserExists,
  } = api;
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();
  const [capatchaReady, setCapatchaReady] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [verifier, setVerifier] = useState(null);
  const countrylistdata = useSelector((state) => state.countrylistdata);
  const [mobileWithoutCountry, setMobileWithoutCountry] = useState('');
  const [countryCode, setCountryCode] = useState();
  const [countryName, setCountryName] = useState();
  const [showSignUp, setShowSignUp] = useState(false);
  const [message, setMessage] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [countries, setCountries] = useState();

  const [data, setData] = React.useState({
    email: '',
    confirmpassword: "",
    country: "",
    contact: '',
    mobile: "",
    password: '',
    otp: '',
    verificationId: null,
    firstName: '',
    lastName: '',
    selectedcountry: null,
    usertype: 'customer',
    referralId: '',
    entryType: null,
    companyName: null,
    companyAddress: null
  });
  const [otpCalled, setOtpCalled] = useState();
  const [serviceCheck, setServiceCheck] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const servicedata = useSelector(state => state.servicedata);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const { ...rest } = props;
  const [services, setServices] = useState();
  const [serviceAddress, setServiceAddress] = useState(null);
  const [localCountry, setLocalCountry] = useState();
  const [typeOfUser, setTypeOfUser] = useState(null);

  const searchLocation = async () => {
      const response = await fetch('https://api.country.is', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
      })
      const json = await response.json();
      if(json){
        setLocalCountry(json.country);
      }
  };

  useEffect(() => {
    if (servicedata && servicedata.service) {
      const activeServices = servicedata.service.filter((item) => {
        return (
          item.active === true && item.service_name !== "Select Your Choice Destination"
        )
      })
      setServices(activeServices);
    }
  }, [servicedata]);

  const handleChangeServiceType = (e) => {
    setData({ ...data, service_type: e.target.value });
  };

  useEffect(() => {
    if (countrylistdata.countries && countrylistdata.countries.length > 0) {
      const countries = countrylistdata.countries.sort((a, b) => a.pos - b.pos);
      let arr = [];
      for (let i = 0; i < countries.length; i++) {
        arr.push({
          label: countries[i].country,
          code: countries[i].country_code,
          phone: countries[i].phone_code,
        });
      }
      setCountries(arr);
      searchLocation();
    }
  }, [countrylistdata.countries]);

  useEffect(() => {
    if (countrylistdata.countries && countrylistdata.countries.length>0) {
        const countries = countrylistdata.countries.sort((a, b) => a.pos - b.pos);
        let arr = [];
        for (let i = 0; i < countries.length; i++) {
          arr.push({
            label: countries[i].country,
            code: countries[i].country_code,
            phone: countries[i].phone_code,
          });
        }
        for (let i = 0; i < countries.length; i++) {
          if(countries[i].country_code === localCountry){
            setData({
              country: countries[i].phone_code,
              selectedcountry: arr[i],
            });
            setCountryCode(countries[i].country + " (+" + countries[i].phone_code + ")")
            setCountryName(countries[i].country);
			break
          }else{
            setData({
              country: countries[0].phone_code,
              selectedcountry: arr[0],
            });
            setCountryCode(countries[0].country + " (+" + countries[0].phone_code + ")")
            setCountryName(countries[0].country);
          }
        } 
    }
  }, [countrylistdata.countries, localCountry]);


  const handelSubmit = () => {
    if (!(data && data.firstName && data.lastName && data.mobile && data.email && data.companyName && data.service_type && serviceAddress)) {
      if (!(data && data.firstName, data.lastName)) {
        setCommonAlert({ open: true, msg: t("proper_input_name") });
      } else if (!data.mobile) {
        setCommonAlert({ open: true, msg: t("mobile_no_blank_error") });
      } else if (!data.email) {
        setCommonAlert({ open: true, msg: t("proper_email") });
      } else if (!data.companyName) {
        setCommonAlert({ open: true, msg: t("company_required") });
      } else if (!data.service_type) {
        setCommonAlert({ open: true, msg: t("service_type_required") });
      } else if (!serviceAddress) {
        setCommonAlert({ open: true, msg: t("service_address_required") });
      }
    } else {
      new Promise((resolve, reject) => {
        setTimeout(() => {
          if (data && data.firstName && data.lastName && data.selectedcountry) {
            data["createdAt"] = new Date().getTime();
            const deliveryLocationData = { ...data, companyAddress: { lat: serviceAddress.coords.lat, lng: serviceAddress.coords.lng, dec: serviceAddress.description },
             usertype: null, referralId: null, password: null, confirmpassword: null, country_code: data.selectedcountry.code, country: data.selectedcountry.label, selectedcountry: null}
            dispatch(editDeliveryLocations(deliveryLocationData, "Add"));
            setServiceCheck(true);
            setMessage(true)
            setData({ ...data, email: "", firstName: "", lastName: "", password: "", confirmpassword: "", usertype: "customer", referralId: "" })
            setMobileWithoutCountry("")
            setIsLoading(false);
            resolve();
          } else {
            setCommonAlert({ open: true, msg: t("proper_input_name") });
            reject(new Error("Enter proper name"));
          }
        }, 600);
      })

    }
  };
  useEffect(() => {
    if (!window.recaptchaVerifier) {
      setCapatchaReady(true);
    }
    if (auth.profile) {
      if (auth.profile.uid) {
        let role = auth.profile.usertype;
        if (role === 'admin' || role === 'fleetadmin') {
          navigate('/dashboard');
        }
        else if (role === 'driver') {
          navigate('/bookings');
        }
        else {
          navigate('/');
        }
      }
    }
    if (auth.error && auth.error.flag && auth.error.msg.message !== t('not_logged_in')) {
      if (auth.error.msg.message === t('require_approval')) {
        setCommonAlert({ open: true, msg: t('require_approval') })
      } else if (auth.error.msg.message === "Firebase: Error (auth/invalid-verification-code).") {
        setCommonAlert({ open: true, msg: t('login_error') })
      } else {
        if (data.contact && (data.contact === '' || !(!data.contact))) {
          setCommonAlert({ open: true, msg: t('login_error') })
        }
      }
    }
    if (auth.verificationId && otpCalled) {
      setOtpCalled(false);
      setData({ ...data, verificationId: auth.verificationId });
    }
  }, [auth.profile, auth.error, auth.verificationId, navigate, data, data.email, data.contact, capatchaReady, RecaptchaVerifier, t, setData, otpCalled, setOtpCalled]);


  const handleGoogleLogin = (credentialResponse) => {
    if (credentialResponse && credentialResponse.credential) {
      dispatch(googleLogin(credentialResponse.credential, null))
    } else {
      setCommonAlert({ open: true, msg: t('login_error') })
      setIsLoading(false);
    }
  }

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' });
    if (auth.error.flag) {
      setData({ ...data, email: '', pass: '' });
      dispatch(clearLoginError());
    }
  };

  const onInputChange = (event) => {
    setData({ ...data, [event.target.id]: event.target.value })
  }

  const handleGetOTP = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (data.country) {
      if (data.contact) {
        if (isNaN(data.contact)) {
          setData({ ...data, entryType: 'email' });
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (re.test(data.contact)) {
            await dispatch(verifyEmailPassword(
              data.contact,
              data.otp
            ));
          } else {
            setCommonAlert({ open: true, msg: t('proper_email') })
            setIsLoading(false);
          }
        } else {
          setData({ ...data, entryType: 'mobile' });
          let formattedNum = data.contact.replace(/ /g, '');
          const phoneNumber = "+" + data.country + formattedNum;
          if (formattedNum.length > 6) {
            checkUserExists({ mobile: phoneNumber }).then(async (res) => {
              if (res.users && res.users.length > 0) {
                if (settings.customMobileOTP) {
                  dispatch(requestMobileOtp(phoneNumber));
                  setData({ ...data, verificationId: true })
                  setIsLoading(false)
                } else {
                  if (!window.recaptchaVerifier || verifier === null) {
                    window.recaptchaVerifier = await new RecaptchaVerifier(authRef(), 'sign-in-button', {
                      'size': 'invisible',
                      'callback': function (response) {
                        setCapatchaReady(true);
                      }
                    });
                  }
                  const appVerifier = window.recaptchaVerifier;
                  setVerifier(appVerifier);
                  await signInWithPhoneNumber(authRef(), phoneNumber, appVerifier)
                    .then(res => {
                      setData({ ...data, verificationId: res.verificationId })
                      setIsLoading(false)
                      window.recaptchaVerifier.clear();
                    })
                    .catch(error => {
                      setCommonAlert({ open: true, msg: error.code + ": " + error.message });
                      setIsLoading(false);
                    });
                }
              } else if (res.error) {

                setCommonAlert({ open: true, msg: t('email_or_mobile_issue') })
                setIsLoading(false);
              } else {
                setCommonAlert({ open: true, msg: t('not_register') })
                setIsLoading(false);
              }
            });
          } else {
            setCommonAlert({ open: true, msg: t('mobile_no_blank_error') })
            setIsLoading(false);
          }
        }
      } else {
        setCommonAlert({ open: true, msg: t('contact_input_error') })
        setIsLoading(false);
      }
    } else {
      setCommonAlert({ open: true, msg: t('country_blank_error') })
      setIsLoading(false);
    }
  }

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (data.otp && data.otp.length === 6) {
      if (settings.customMobileOTP) {
        let formattedNum = data.contact.replace(/ /g, '');
        const phoneNumber = "+" + data.country + formattedNum;
        dispatch(verifyMobileOtp(
          phoneNumber,
          data.otp
        ));
      } else {
        await dispatch(mobileSignIn(
          data.verificationId,
          data.otp
        ));
      }
      setIsLoading(false);
    } else {
      setCommonAlert({ open: true, msg: t('otp_validate_error') })
      setIsLoading(false);
    }
  }

  const handleCancel = (e) => {
    setData({
      ...data,
      contact: null,
      verificationId: null
    });
    setIsLoading(false);
  }

  const onCountryChange = (object, value) => {
    if (value && value.phone) {
      setData({ ...data, country: value.phone, selectedcountry: value });
      setCountryCode(value.code + " (+" + value.phone + ")")
      setCountryName(value.label)
    }
  };

  const forgotPassword = async (e) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let abc = data.contact
    checkUserExists({ email: abc }).then(async (res) => {
      if (res.users && res.users.length > 0) {
        if (re.test(abc)) {

          await dispatch(sendResetMail(data.contact));
          setCommonAlert({ open: true, msg: t('email_send') });
        } else {
          setCommonAlert({ open: true, msg: t('proper_email') });
        }
      } else {
        setCommonAlert({ open: true, msg: t('not_register') });
      }
    });
  };

  const handleShowSignup = () => {
    setData({ ...data, email: "", firstName: "", lastName: "", password: "", confirmpassword: "", usertype: typeOfUser, referralId: "" });
    setMobileWithoutCountry("");
    setShowSignUp(!showSignUp);
    setMessage(false);
    setServiceCheck(false);
  }

  const mobileInputChange = (e) => {
    const val = e.target.value;
    setMobileWithoutCountry(val)
    let formattedNum = val.replace(/ /g, '');
    formattedNum = countryCode.split("(")[1].split(")")[0] + formattedNum.replace(/-/g, '');
    setData({ ...data, mobile: formattedNum })

  }

  // const handleChangeUser = (event) => {
  //   setData({ ...data, usertype: event.target.value });
  // };

  const change = (event) => {
    setShowSignUp(false)
    setTypeOfUser(null)
  };

  const handleTypeOfUser = (event) => {
    setTypeOfUser(event.target.value);
  };

  const checkPasswordValidity = value => {
    if (value !== data.confirmpassword) {
      return (t('confirm_password_not_match_err'));
    }

    const isNonWhiteSpace = /^\S*$/;
    if (!isNonWhiteSpace.test(value)) {
      return (t('password_must_not_contain_whitespaces'));
    }

    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(value)) {
      return (t('password_must_have_at_least_one_uppercase_character'));
    }

    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(value)) {
      return (t('password_must_have_at_least_one_lowercase_character'));
    }

    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(value)) {
      return (t('password_must_contain_at_least_one_digit'));
    }

    const isValidLength = /^.{8,16}$/;
    if (!isValidLength.test(value)) {
      return (t('password_must_be_8-16_characters_long'));
    }

    return null;
  }

  const validateMobile = () => {
    let mobileValid = true;
    if (mobileWithoutCountry.length < 6) {
      mobileValid = false;
      setCommonAlert({ open: true, msg: t('mobile_no_blank_error') })
    }
    return mobileValid;
  }


  const handleSignUp = (e) => {
    e.preventDefault();
    new Promise((resolve, reject) => {
      setIsLoading(true)
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const validatePassword = checkPasswordValidity(data.password);
      if (data.usertype === 'shipper' && (!data.companyAddress || !data.companyName)) {
        setIsLoading(false)
        setCommonAlert({ open: true, msg: t('proper_company_details') })
        reject();
        return;
      }
      if (data.usertype === 'services' && (!data.companyAddress || !data.companyName || !data.service_type)) {
        setIsLoading(false)
        setCommonAlert({ open: true, msg: t('proper_company_details') })
        reject();
        return;
      }
      if (re.test(data.email)) {
        if (/\S/.test(data.firstName) && data.firstName.length > 0 && /\S/.test(data.lastName) && data.lastName.length > 0) {
          if (!validatePassword) {
            if (validateMobile()) {
              const userData = { ...data };
              if (!userData.symbol) {
                let choseCountry = [];
                if (countrylistdata.countries && countrylistdata.countries.length > 0) {
                  const countries = countrylistdata.countries;
                  for (let i = 0; i < countries.length; i++) {
                    if (countries[i].country === countryName) {
                      choseCountry.push(countries[i]);
                      break;
                    }
                  }
                }
                if (choseCountry.length > 0) {
                  userData.country = choseCountry[0].country;
                  userData.swipe_symbol = choseCountry[0].swipe_symbol;
                  userData.country_code = choseCountry[0].country_code;
                  userData.currency_code = choseCountry[0].currency_code;
                  userData.symbol = choseCountry[0].symbol;
                }
              }

              if (userData.usertype === 'customer') delete userData.carType
              delete userData.confirmpassword;
              delete userData.pass;
              checkUserExists(userData).then((res) => {
                if (res.users && res.users.length > 0) {
                  setCommonAlert({ open: true, msg: t('user_exists') })
                  setIsLoading(false);
                  reject();
                } else {
                  mainSignUp(userData).then((res) => {
                    if (res.uid) {
                      setData({ ...data, email: "", firstName: "", lastName: "", password: "", confirmpassword: "", usertype: "customer", referralId: "" })
                      setMobileWithoutCountry("")
                      setMessage(true)
                      setIsLoading(false);
                      resolve();
                    } else {
                      setCommonAlert({ open: true, msg: t('reg_error') })
                      setIsLoading(false);
                    }
                  });
                }
              });

            } else {
              setCommonAlert({ open: true, msg: t('mobile_no_blank_error') })
              reject();
            }
          } else {
            setCommonAlert({ open: true, msg: validatePassword })
            reject();
           }
        } else {
          setCommonAlert({ open: true, msg: t('proper_input_name') })
          reject();
        }
      } else {
        setCommonAlert({ open: true, msg: t('proper_email') })
        reject();
      }
    }).catch(() => { }).finally(() => { setIsLoading(false) })
  }

  return (
    <div>
      <Header
        absolute
        color="transparent"
        rightLinks={<HeaderLinks />}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: "url(" + image + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          display: 'flex'
        }}
      >
        {showSignUp ?
          <div className={classes.container}>
            <GridContainer justifyContent="center">
              <GridItem xs={12} sm={12} md={8}>
                <Card>
                  <form className={classes.form}>
                    <CardHeader
                      style={{
                        backgroundColor: "#2C3D44",
                        borderRadius: 5,
                      }}
                      className={classes.cardHeader}
					  
                    >
                     <h4 className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription}  style={{ textAlign:'center', textTransform: '', color: colors.WHITE, fontSize: 20 }}>{t("signup")}</h4>
						<h4 className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} style={{ fontWeight : 'bold', textAlign: 'center', color: colors.WHITE, fontSize: 20, textTransform: 'uppercase' }}>
                               {typeOfUser === 'customer' ? t('ragister_as_customer') :
                                  typeOfUser === 'driver' ? t('ragister_as_driver') :
                                  typeOfUser === 'shipper' ? t('ragister_as_shipper') :
                                        t('ragister_as_services')}
                          </h4>
					{settings && settings.socialLogin ?
				     <div className={classes.socialLine} style={{ alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
                            <div className={classes.socialLine}>
                              <Button
                                justIcon
                                href="#pablo"
                                target="_blank"
                                color="transparent"
                              >
                                <GoogleLogin
                                  onSuccess={handleGoogleLogin}
                                  onError={handleGoogleLogin}
                                />
                              </Button>
                            </div>
                          </div>
					:null}
                    </CardHeader>
					
                    <CardBody style={{ marginBottom: 40 }}>
                      <GridContainer
                        spacing={2}
                        sx={{
                          display: "flex",
                          gridTemplateColumns: "50%",
                        }}
                      >
                        <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                          <CustomInput
                            labelText={t("first_name")}
                            id="firstName"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <AccountBoxIcon
                                    className={classes.inputIconsColor}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            onChange={onInputChange}
                            value={data.firstName}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                          <CustomInput
                            labelText={t("last_name")}
                            id="lastName"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <AccountBoxIcon
                                    className={classes.inputIconsColor}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            onChange={onInputChange}
                            value={data.lastName}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                          {data.selectedcountry && settings.mobileLogin && countries && countries.length > 0 ?
                            <CountrySelect
                              countries={countries}
                              label={t('select_country')}
                              value={data.selectedcountry}
                              onChange={onCountryChange}
                              style={{ paddingTop: 20 }}
                              disabled={data.verificationId ? true : false}
                            />
                            : null}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                          <CustomInput
                            labelText={t("phone")}
                            id="mobileWithoutCountry"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <LocalPhoneIcon
                                    className={classes.inputIconsColor}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            onChange={mobileInputChange}
                            value={mobileWithoutCountry}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                          <CustomInput
                            labelText={t("email")}
                            id="email"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <EmailIcon
                                    className={classes.inputIconsColor}
                                  />
                                </InputAdornment>
                              ),
                            }}
                            onChange={onInputChange}
                            value={data.email}
                          />
                        </GridItem>
                        {data.usertype !== 'services' ?
                          <>
                            <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                              <CustomInput
                                labelText={t("password")}
                                id="password"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: showPassword ? "text" : "password",
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <VisibilityIcon
                                        className={classes.inputIconsColor}
                                        onClick={() => setShowPassword(!showPassword)}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={onInputChange}
                                value={data.password}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                              <CustomInput
                                labelText={t("confirm_password")}
                                id="confirmpassword"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: showConfirmPassword ? "text" : "password",
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <VisibilityIcon
                                        className={classes.inputIconsColor}
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={onInputChange}
                                value={data.confirmpassword}
                              />
                            </GridItem>
                          </>
                          : null}
                        {data.usertype === 'shipper' || data.usertype === 'services' ?
                          <>
                            <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                              <CustomInput
                                labelText={t("companyName")}
                                id="companyName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <House
                                        className={classes.inputIconsColor}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={onInputChange}
                                value={data.companyName}
                              />
                            </GridItem>
                            {data.usertype === 'services' ?
                              <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                                <FormControl
                                  fullWidth
                                  style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                                >
                                  <InputLabel
                                    id="demo-simple-select-label"
                                    className={isRTL === "rtl" ? classes.right : ""}
                                    sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}
                                  >
                                    {t("service_type")}
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="service_type"
                                    value={data.service_type || ""}
                                    label={t("service_type")}
                                    onChange={handleChangeServiceType}
                                    className={
                                      isRTL === "rtl"
                                        ? classes.selectField_rtl
                                        : classes.selectField
                                    }
                                  >
                                    {services?.map((item, idx) =>
                                      <MenuItem
                                        style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                                        value={item.service_name}
                                        key={idx}
                                      >
                                        {item.service_name}
                                      </MenuItem>
                                    )}
                                  </Select>
                                </FormControl>
                              </GridItem>
                              : null}

                            <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                              {data.usertype !== 'services' ?
                                <GoogleMapsAutoComplete
                                  variant={"outlined"}
                                  placeholder={data.usertype === 'services' ? t('service_address') : t('company_address')}
                                  value={data.companyAddress ? data.companyAddress.dec : ""}
                                  className={classes.items}
                                  onChange={
                                    (value) => {
                                      setData({ ...data, companyAddress: { dec: value.description, lat: value.coords.lat, lng: value.coords.lng } })
                                    }
                                  }
                                />
                                :
                                <GoogleMapsAutoComplete
                                  variant={"outlined"}
                                  placeholder={t('service_address')}
                                  value={serviceAddress}
                                  className={classes.items}
                                  onChange={
                                    (value) => {
                                      setServiceAddress(value);
                                    }
                                  }
                                />
                              }
                            </GridItem>
                          </> : null}
                        {data.usertype !== 'services' ?
                          <>
                            <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                              <CustomInput
                                labelText={t("referralId")}
                                id="referralId"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <AccountBoxIcon
                                        className={classes.inputIconsColor}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={onInputChange}
                                value={data.referralId}
                              />
                            </GridItem>
                          </>
                          : null}

                      </GridContainer>
                    </CardBody>
                    <CardFooter className={classes.cardFooter} style={{ marginBottom: 30 }}>
                      {message ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                          <Typography style={{ color: colors.GREEN, fontWeight: "bold" }}>{ serviceCheck ? t("service_station_add_successfully") : t("account_create_successfully")}</Typography>
                          <Button className={classes.normalButton} simple color="info" onClick={() => change()}>
                            {t('signIn')}
                          </Button>
                        </div>
                      ) : isLoading ? (
                        <DialogActions
                          style={{
                            justifyContent: "center",
                            alignContent: "center",
                          }}
                        >
                          <CircularProgress />
                        </DialogActions>
                      ) : (
                        <>
                          {data.usertype === 'services' ?
                          <Button className={classes.normalButton} simple color="info" size="lg" variant="contained" onClick={handelSubmit}>
                            {t('add_service')}
                          </Button>
                          :
                          <Button className={classes.normalButton} simple color="info" size="lg" type="submit" onClick={handleSignUp}>
                            {t('signup')}
                          </Button>
                          }
                          <Button className={classes.normalButton} simple color="info" size="lg" onClick={handleShowSignup}>
                            {t('login')}
                          </Button>
                        </>
                      )}
                    </CardFooter>
                  </form>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
          :
          <>
            <div id="sign-in-button" />
            <div className={classes.container}>
              <GridContainer justifyContent="center">
                <GridItem xs={12} sm={12} md={4}>
                  <Card>
                    <form className={classes.form}>

                        <CardHeader style={{
                          backgroundColor: "#ec9222",
                          borderRadius: 5,
                        }} className={classes.cardHeader}>
						{typeOfUser === 'account' ? 
						<>
                          <h4 className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} style={{  fontWeight:'bold',textAlign: 'center', color: colors.WHITE, fontSize: 20,  textTransform: 'uppercase' }}>{t('login')}</h4>
						</>
						 :
						<>
						  <h4 className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} style={{ textAlign: 'center', color: colors.WHITE, fontSize: 20,  textTransform: '' }}>{t('authentication')}</h4>
						  <h4 className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} style={{ fontWeight:'bold', textAlign: 'center', color: colors.WHITE, fontSize: 20,  textTransform: 'uppercase' }}>{t('loginregister')}</h4>
						</>
						}
						{settings && settings.socialLogin ?
                          <div className={classes.socialLine} style={{ alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
                            <div className={classes.socialLine}>
                              <Button
                                justIcon
                                href="#pablo"
                                target="_blank"
                                color="transparent"
                              >
                                <GoogleLogin
                                  onSuccess={handleGoogleLogin}
                                  onError={handleGoogleLogin}
                                />
                              </Button>
                            </div>
                          </div>
						: null}
                        </CardHeader>



                        <GridItem xs={12} sm={12} md={12} lg={12} xl={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <FormControl fullWidth style={{ direction: isRTL === "rtl" ? "rtl" : 'ltr' }}>
                            <InputLabel id="demo-simple-select-label" className={isRTL === "rtl" ? classes.right : ""} sx={{ "&.Mui-focused": { color: MAIN_COLOR } }}>
                              {t("select_desired_action")}
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={typeOfUser || ""}
                              label={t("select_desired_action")}
                              onChange={handleTypeOfUser}
                              className={classes.selectField}
                              aria-label="typeOfUser"
                              style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left', borderRadius: 5, height: 65, width: '100%', marginBottom: 20 }}
                            >
                              <MenuItem value={"account"}>{t('login_to_my_account')}</MenuItem>
                              <MenuItem value={"customer"}>{t('ragister_as_customer')}</MenuItem>
                              <MenuItem value={"driver"}>{t('ragister_as_driver')}</MenuItem>
                              <MenuItem value={"shipper"}>{t('ragister_as_shipper')}</MenuItem>
                              <MenuItem value={"services"}>{t('ragister_as_services')}</MenuItem>
                            </Select>
                          </FormControl>
                        </GridItem>

                      {typeOfUser === 'account' ?
                      <CardBody style={{ marginBottom: 10 }}>
                        {data.selectedcountry && settings.mobileLogin && countries && countries.length > 0 ?
                          <CountrySelect
                            countries={countries}
                            label={t('select_country')}
                            value={data.selectedcountry}
                            onChange={onCountryChange}
                            style={{ paddingTop: 20 }}
                            disabled={data.verificationId ? true : false}
                          />
                          : null}

                        <CustomInput
                          labelText={settings.emailLogin && settings.mobileLogin ? t('contact_placeholder') : settings.emailLogin && !settings.mobileLogin ? t('email_id') : t('mobile_number')}
                          id="contact"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            required: true,
                            disabled: data.verificationId ? true : false,
                            endAdornment: (
                              <InputAdornment position="start">
                                <AccountBoxIcon className={classes.inputIconsColor} />
                              </InputAdornment>
                            )
                          }}
                          onChange={onInputChange}
                          value={data.contact}
                        />
                        {(data.contact && isNaN(data.contact)) || (settings.emailLogin && !settings.mobileLogin) ?
                          <CustomInput
                            labelText={((data.contact && isNaN(data.contact)) || (settings.emailLogin && !settings.mobileLogin)) ? t('password') : t('otp_here')}
                            id="otp"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "password",
                              required: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <Icon className={classes.inputIconsColor}>
                                    lock_outline
                                  </Icon>
                                </InputAdornment>
                              ),
                              autoComplete: "off"
                            }}
                            onChange={onInputChange}
                            value={data.otp}
                          />
                          : null}

                        {data.verificationId ?
                          <CustomInput
                            labelText={t('otp')}
                            id="otp"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              type: "password",
                              required: true,
                              endAdornment: (
                                <InputAdornment position="start">
                                  <Icon className={classes.inputIconsColor}>
                                    lock_outline
                                  </Icon>
                                </InputAdornment>
                              ),
                              autoComplete: "off"
                            }}
                            onChange={onInputChange}
                            value={data.otp}
                          />
                          : null}

                      </CardBody>
                      : null }

                      {typeOfUser === 'account' ?
                      <CardFooter className={classes.cardFooter} style={{ marginBottom: 10 }}>
                        {isLoading ?
                          <DialogActions style={{ justifyContent: 'center', alignContent: 'center' }}>
                            <CircularProgress />
                          </DialogActions>
                          :
                          !data.verificationId ?
                            <div>
                              <Button className={classes.normalButton} simple color="primary" size="lg" type="submit" onClick={handleGetOTP}>
                                {data.contact && isNaN(data.contact) ? t('login') : t('login_otp')}
                              </Button>
                              {data.contact && isNaN(data.contact) ?
                                <Button className={classes.normalButton} simple color="primary" size="lg" onClick={() => forgotPassword()}>
                                  {t('forgot_password')}
                                </Button>
                                : null}
                            </div>
                            :
                            <div>
                              <Button className={classes.normalButton} simple color="primary" size="lg" type="submit" onClick={handleVerifyOTP}>
                                {t('verify_otp')}
                              </Button>
                              <Button className={classes.normalButton} simple color="primary" size="lg" onClick={handleCancel}>
                                {t('cancel')}
                              </Button>
                            </div>
                        }
                      </CardFooter>
                    : null }
                    </form>


                    {typeOfUser !== 'account' && typeOfUser !== null ?
                      !isLoading ?
                        <Button className={classes.normalButton} simple color="primary" type="submit" size="lg" onClick={handleShowSignup}>
                          {typeOfUser === 'customer' ? t('ragister_as_customer') : typeOfUser === 'driver' ?  t('ragister_as_driver') : typeOfUser === 'shipper' ? t('ragister_as_shipper') : t('ragister_as_services')}
                        </Button>
                        : null
                    : null }
                  </Card>
                </GridItem>
              </GridContainer>
            </div>
          </>
        }
        <Footer whiteFont />
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </div>
    </div>
  );
}